var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"app":""}},[_c('div',{staticClass:"d-flex flex-column flex-grow-1 h-full"},[(_vm.$router.currentRoute.name === 'Dashboard')?_c('AppHeader'):_vm._e(),_c('AppContainer'),(_vm.$router.currentRoute.name === 'Dashboard')?_c('AppFooter'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }